import { useQuery } from "@tanstack/react-query";

import { useAuthHeaders } from "../auth/apiClient";

export interface ReviewFeedbackItem {
  rating: number;
  customer_name: string;
  ghosted?: boolean;
  customer_phone_masked: string;
  comment: string;
  received_at: string;
  quote_id: string;
  amount: number;
  route_code: string;
}

export function useReviewsFeedback(limit = 20) {
  const headers = useAuthHeaders();
  return useQuery({
    queryKey: ["reviews", "feedback", limit],
    queryFn: async () => {
      const res = await fetch(`/api/cockpit/reviews/feedback?limit=${limit}`, {
        headers,
      });
      if (!res.ok) throw new Error("Reviews feedback failed");
      return res.json() as Promise<{ items: ReviewFeedbackItem[] }>;
    },
    staleTime: 5 * 60_000,
  });
}
